import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth-service';
import { from, of, switchMap, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

const AUTH_BOOTSTRAP_PATHS = ['/user/select-subtenant', '/user/subtenants'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  const isApiRequest = req.url.startsWith(environment.apiUrl) ||
    (req.url.startsWith('/') && !req.url.startsWith('http'));

  if (!isApiRequest) {
    return next(req);
  }

  const isBootstrapRequest = AUTH_BOOTSTRAP_PATHS.some((path) => req.url.includes(path));

  if (isBootstrapRequest) {
    return from(authService.getAccessToken()).pipe(
      catchError(() => of(null)),
      switchMap((cognitoToken) => {
        const bootstrapReq = cognitoToken
          ? req.clone({ setHeaders: { Authorization: `Bearer ${cognitoToken}` } })
          : req;
        return next(bootstrapReq);
      })
    );
  }

  return from(authService.getValidToken()).pipe(

    catchError(() => of(null)),

    switchMap((token) => {

      if (token && authService.isTokenExpired(token)) {
        return from(authService.refreshAppToken()).pipe(
          catchError(() => of(null))
        );
      }

      return of(token);
    }),

    switchMap((token) => {

      if (token) {
        const clonedRequest = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next(clonedRequest).pipe(

          catchError((error) => {
            if (error.status === 401) {
              return from(authService.refreshAppToken()).pipe(
                switchMap((newToken) => {

                  if (!newToken) return throwError(() => error);

                  const retryReq = req.clone({
                    setHeaders: {
                      Authorization: `Bearer ${newToken}`,
                    },
                  });

                  return next(retryReq);
                })
              );
            }

            return throwError(() => error);
          })
        );
      }
      return next(req);
    })
  );
};
